<template>
  <div class="print-qr-page">
    <div v-if="isLoading" class="print-status">
      <i class="ti-reload"></i>
      <strong>Menyiapkan QR Code...</strong>
      <span>Halaman print akan terbuka setelah seluruh QR Code selesai dibuat.</span>
    </div>

    <div v-else-if="errorMessage" class="print-status print-status--error">
      <i class="ti-alert"></i>
      <strong>QR Code tidak dapat dimuat</strong>
      <span>{{ errorMessage }}</span>
      <button type="button" class="btn btn-primary" @click="DataQuery">
        Coba Lagi
      </button>
    </div>

    <template v-else>
      <header class="print-qr-header">
        <div>
          <span class="print-eyebrow">TBI Station Dashboard</span>
          <h1>{{ contractName }}</h1>
          <p>QR Code Area &amp; Section Room</p>
        </div>
        <div class="print-qr-summary">
          <small>Contract ID</small>
          <strong>#{{ contractId }}</strong>
          <span>{{ model_section.length }} area</span>
        </div>
      </header>

      <div class="print-qr-grid">
        <article
          v-for="(items, idx) in model_section"
          :key="items.id || idx"
          class="print-qr-card"
        >
          <VueQRCodeComponent
            :text="contractId + '-' + items.id"
            :size="210"
          ></VueQRCodeComponent>
          <div class="print-qr-detail">
            <strong>{{ items.area_name || "Area tanpa nama" }}</strong>
            <span>Section {{ items.section }}</span>
            <span>Lantai {{ items.area_floor }}</span>
            <span>{{ items.area_type }}</span>
            <code>{{ contractId }}-{{ items.id }}</code>
          </div>
        </article>
      </div>

      <div class="print-actions">
        <button type="button" class="btn btn-primary" @click="printPage">
          <i class="ti-printer"></i> Print QR Code
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    VueQRCodeComponent,
  },
  data() {
    return {
      contractId: localStorage.getItem("QUERY_ID"),
      contractName: "Kontrak",
      model_section: [],
      isLoading: true,
      errorMessage: "",
    };
  },
  created() {
    this.DataQuery();
  },
  methods: {
    flattenSections(source) {
      const result = [];

      const collect = (value, categoryType) => {
        if (!value) return;

        if (Array.isArray(value)) {
          value.forEach((item) => collect(item, categoryType));
          return;
        }

        if (typeof value !== "object") return;

        const nextCategory = value.category_type || categoryType;

        if (value.id && value.area_name !== undefined) {
          result.push({
            ...value,
            category_type: nextCategory,
          });
          return;
        }

        if (Array.isArray(value.data)) {
          collect(value.data, nextCategory);
          return;
        }

        Object.keys(value).forEach((key) => {
          if (key !== "category_type") collect(value[key], nextCategory);
        });
      };

      collect(source, null);
      return result;
    },
    async DataQuery() {
      this.isLoading = true;
      this.errorMessage = "";

      try {
        const query = await this.$store.dispatch("crud/find", {
          url: "contract/find/" + this.contractId,
        });

        this.contractName =
          (query.contract &&
            (query.contract.client_name || query.contract.name)) ||
          query.client_name ||
          query.name ||
          "Kontrak";
        this.model_section = this.flattenSections(query.section);

        if (!this.model_section.length) {
          throw new Error("Data section room tidak ditemukan pada kontrak ini.");
        }

        this.isLoading = false;
        await this.waitForQrRender();
        this.printPage();
      } catch (error) {
        this.isLoading = false;
        this.errorMessage =
          error && error.message
            ? error.message
            : "Terjadi masalah saat mengambil data section room.";
      }
    },
    waitForQrRender() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => resolve());
          });
        });
      });
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
.print-qr-page {
  background: #fff;
  color: #29485b;
  left: 0;
  min-height: 100vh;
  padding: 28px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 9999;
}

.print-qr-header {
  align-items: center;
  border-bottom: 2px solid #20a8b4;
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
  padding-bottom: 16px;
}

.print-eyebrow {
  color: #1698a5;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.print-qr-header h1 {
  color: #29485b;
  font-size: 24px;
  margin: 5px 0 2px;
}

.print-qr-header p {
  color: #738995;
  margin: 0;
}

.print-qr-summary {
  background: #eef8f9;
  border: 1px solid #d5e9eb;
  border-radius: 10px;
  min-width: 150px;
  padding: 10px 14px;
  text-align: right;
}

.print-qr-summary small,
.print-qr-summary strong,
.print-qr-summary span {
  display: block;
}

.print-qr-summary small,
.print-qr-summary span {
  color: #718792;
  font-size: 10px;
}

.print-qr-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.print-qr-card {
  align-items: center;
  border: 1px dashed #78939e;
  break-inside: avoid;
  display: flex;
  gap: 18px;
  min-height: 240px;
  padding: 14px;
  page-break-inside: avoid;
}

.print-qr-detail {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.print-qr-detail strong {
  color: #203f50;
  font-size: 16px;
  margin-bottom: 8px;
  overflow-wrap: anywhere;
}

.print-qr-detail span {
  color: #657d89;
  font-size: 12px;
  line-height: 1.6;
}

.print-qr-detail code {
  background: #f0f5f6;
  border-radius: 4px;
  color: #3e6676;
  font-size: 10px;
  margin-top: 9px;
  padding: 4px 6px;
  width: fit-content;
}

.print-actions {
  margin-top: 20px;
  text-align: right;
}

.print-status {
  align-items: center;
  background: #f2fafb;
  border: 1px solid #d7eaec;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 80px auto;
  max-width: 520px;
  padding: 34px;
  text-align: center;
}

.print-status i {
  color: #189ba7;
  font-size: 28px;
}

.print-status span {
  color: #728792;
}

.print-status--error {
  background: #fff8f3;
  border-color: #f3d9ca;
}

@media print {
  .print-qr-page {
    padding: 0;
    position: static;
  }

  .print-actions {
    display: none !important;
  }

  .print-qr-header {
    margin-bottom: 14px;
  }

  .print-qr-grid {
    gap: 8mm;
  }

  .print-qr-card {
    min-height: 74mm;
  }
}

@media (max-width: 767px) {
  .print-qr-page {
    padding: 16px;
  }

  .print-qr-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .print-qr-summary {
    text-align: left;
  }

  .print-qr-grid {
    grid-template-columns: 1fr;
  }
}
</style>
